import * as NProgress from 'nprogress';
import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

const loadingBarSelector = '#loading-bar';
const int = setInterval(() => {
  if (document.querySelector(loadingBarSelector)) {
    NProgress.configure({ parent: loadingBarSelector });
    clearInterval(int);
  }
}, 100);

let activeRequest = 0;

export const nprogressRequestInterceptorV2 = (
  config: InternalAxiosRequestConfig
) => {
  activeRequest++;
  NProgress.start();
  return config;
};

export const nprogressResponseInterceptorV2 = (response: AxiosResponse) => {
  activeRequest--;
  if (!activeRequest) {
    NProgress.done();
  }
  return response;
};

export const nprogressErrorInterceptorV2 = (error: AxiosError) => {
  activeRequest--;
  if (!activeRequest) {
    NProgress.done();
  }
  return Promise.reject(error);
};
